import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLanguageStore = defineStore('language', () => {
  const currentLanguage = ref('zh-TW')
  const availableLanguages = [
    { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'jp', name: '日本語', flag: '🇯🇵' }
  ]

  const setLanguage = (languageCode) => {
    const language = availableLanguages.find(lang => lang.code === languageCode)
    if (language) {
      currentLanguage.value = languageCode
      localStorage.setItem('hongkai-language', languageCode)
    }
  }

  const toggleLanguage = () => {
    const currentIndex = availableLanguages.findIndex(lang => lang.code === currentLanguage.value)
    const nextIndex = (currentIndex + 1) % availableLanguages.length
    setLanguage(availableLanguages[nextIndex].code)
  }

  const getCurrentLanguage = () => {
    return availableLanguages.find(lang => lang.code === currentLanguage.value) || availableLanguages[0]
  }

  return {
    currentLanguage,
    availableLanguages,
    setLanguage,
    toggleLanguage,
    getCurrentLanguage
  }
})